import { useCentralStore } from "../../store/Central";
import {
	sendMonatsrechnungSharedEmail,
	sendAkontoRechnungSharedEmail,
	sendSharedFileEmail,
} from "@/lib/email";
import type { TableInvoiceRow } from "../../pages/debitoren/types/invoice-table.types";
import { InvoiceType } from "../../types/database-enums/invoices-enums";
import { buildShareLink } from "@/lib/utils/build-share-link";
import { environment } from "../../lib/utils/environment";
import { ShareEmailDialog } from "../share-email-dialog/share-email-dialog.component";

interface InvoiceShareEmailDialogProps {
	open: boolean;
	onClose: () => void;
	invoice: TableInvoiceRow;
	connectedOrganizationEmail: string;
}

export const InvoiceShareEmailDialog: React.FC<
	InvoiceShareEmailDialogProps
> = ({ open, onClose, invoice, connectedOrganizationEmail }) => {
	const { organization, connectedOrganizationType } = useCentralStore(
		(state) => ({
			organization: state.organization,
			connectedOrganizationType: state.connectedOrganizationType,
		})
	);

	const handleSend = async (message: string | undefined) => {
		const link =
			invoice.file_id && organization?.id
				? buildShareLink({
						fileId: invoice.file_id,
						recipientEmail: connectedOrganizationEmail,
						senderOrgId: organization.id,
						recipientOrgType: connectedOrganizationType,
						dentconnectUrl: environment.VITE_DENTCONNECT_URL,
					})
				: "";
		const invoiceNumber = invoice.invoice_doc_number || "";
		const labName = organization?.name || "";

		if (invoice.invoice_type === InvoiceType.MONATSRG) {
			return sendMonatsrechnungSharedEmail({
				recipientEmail: connectedOrganizationEmail,
				labName,
				invoiceNumber,
				link,
				message,
			});
		}
		if (invoice.invoice_type === InvoiceType.AKONTORECHNUNG) {
			return sendAkontoRechnungSharedEmail({
				recipientEmail: connectedOrganizationEmail,
				labName,
				invoiceNumber,
				link,
				message,
			});
		}
		return sendSharedFileEmail({
			recipientEmail: connectedOrganizationEmail,
			fileName: `Rechnung ${invoiceNumber}`,
			link,
			message: message || "",
		});
	};

	return (
		<ShareEmailDialog
			open={open}
			title="Rechnung wurde geteilt"
			description="Möchten Sie den Empfänger per E-Mail benachrichtigen?"
			ariaLabel="E-Mail-Benachrichtigung für geteilte Rechnung"
			testIdPrefix="invoice-share-email"
			onSend={handleSend}
			onClose={onClose}
		/>
	);
};
